<!-- /firstSection/ -->
<template>
  <div class="firstSectionContainer">
    <img class="polygon" :src="Polygon" alt="Polygon1" />
    <Navbar />
    <div class="titleContainer">
      <div class="imageContainer">
        <img class="img" :src="img" alt="img" />
        <h1 class="title">Une nouvelle expérience du financement</h1>
        <button class="signInBtn ">
          <Icon class="icon" icon="fluent:arrow-right-24-regular" height="20" />
          <a  href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" class="text" target="_blank" style="color: white; text-decoration: none;"><span>Demande d’inscription </span></a> 
        </button>
      </div>

    </div>
    <div class="textContainer">
      <p class="bold">Notre promesse : Financer un dossier en quelques clics.</p>
      <p>Gagnez un temps précieux en publiant les demandes de financements de
vos clients sur un outil unique, pour ensuite recevoir très rapidement toutes
les propositions des différentes banques partenaires .</p>
    </div>
    <div class="textContainerWithactions">
      <p class="title">
        C’est possible avec Prexange !
      </p>
      <p>Tentez l’expérience et vous gagnerez en sérénité au
        quotidien</p>
    </div>
    <div class="btnContainerWithactions">
      <button class="actionButton">
        <Icon class="icon" icon="fluent:arrow-right-24-regular" height="24" />
        <a href="/ccmarche.pdf" target="_blank" style="text-decoration: none;color: white;">Comment ça marche ?</a> 
      </button>
        <a type='button' href="https://us17.list-manage.com/contact-form?u=12eb10c034208fa73e5a394c1&form_id=3349a43f091cf8acd4ccbbef24d933e5" target="_blank" class="actionButtonSecandary" style="text-decoration: none;"><span class="text1"> Démarrer une collaboration </span>
        <span class="text2">
          Contact
        </span>
      </a>
    </div>
  </div>

</template>

<script>
import Polygon from '@/assets/images/Polygon1.png';
import img from '@/assets/images/firstSectionImage.png';
import Navbar from '../navbar/navbar.vue';
import { Icon } from '@iconify/vue2';



export default {
  name: 'FirstSection',
  components: {
    Navbar,
    Icon
  },
  data() {
    return {
      Polygon: Polygon,
      img: img,
      isSidebarOpen: false,
    };
  },

};
</script>


<style lang="scss">
@import './firstSection.scss'
</style>